import { Component, OnInit } from '@angular/core';
import {GiftCardsService} from "../../../services/gift-cards.service";
import {GiftCardBrand, GiftCardBrandCategory} from "../../../dto/order";

@Component({
  selector: 'app-gift-card-brands',
  templateUrl: './gift-card-brands.component.html',
  styleUrls: ['./gift-card-brands.component.css']
})
export class GiftCardBrandsComponent implements OnInit {
  brands: GiftCardBrand[] = [];
  brandCategories: GiftCardBrandCategory[] = [];

  constructor(
    private giftCardsService: GiftCardsService,
  ) { }


  public isLoading = false;


  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.giftCardsService.getBrandCategories().subscribe(gcBrandCategories => {
      this.brandCategories = gcBrandCategories;
      this.giftCardsService.getBrands().subscribe(gcBrands => {
        gcBrands.forEach(gcBrand => {
          console.log("category id " + gcBrand.categoryId + " " + gcBrand.name)
          if ( gcBrand.categoryId )
            gcBrand.category = this.brandCategories.find(gcBrandCategory => gcBrandCategory.id == gcBrand.categoryId);
        })
        this.brands = gcBrands;
        this.isLoading = false;
      })
    })

  }


  protected readonly JSON = JSON;
}
